/**
 * Visually matches TitleH4 but renders a <p>, not a heading — footer link-group
 * titles sit outside the document's heading hierarchy on purpose, so they never
 * create a level-skip relative to whatever heading level the page content above
 * them ends on. Mirrors the legacy site's `<p class="h4 ...">` pattern.
 */
const FooterSectionTitle = ({
  className,
  title,
  small,
}: {
  className?: string;
  title: string;
  small?: boolean;
}) => {
  const sizeClasses = small
    ? "text-[10px] leading-[1.35]"
    : "text-[16px] leading-[1.35] lg:text-[17px] xl:text-[20px] xl:leading-[1.3636]";

  return (
    <p
      className={`text-primary font-semibold tracking-normal ${sizeClasses} ${className ?? ""}`}
    >
      {title}
    </p>
  );
};

export default FooterSectionTitle;
